module.exports = __webpack_public_path__ + "img/map.144d8480.svg";